// TerminosCondicionesToppings.jsx
import React, { useEffect } from "react";
import { Container, Typography, Divider, Box, Link } from "@mui/material";
import logo from "../../Recursos/logo.svg"; // tu logo o el de Toppings

export default function TerminosCondicionesToppings() {
    useEffect(() => {
        // SEO: title
        document.title = "Términos y Condiciones - Toppings Colón";

        // SEO: meta description
        const meta = document.querySelector('meta[name="description"]');
        const description =
            "Términos y condiciones de uso del sitio web Toppings en Colón. Disfruta de comida rápida, helados y bebidas con los mejores toppings.";
        if (meta) {
            meta.setAttribute("content", description);
        } else {
            const m = document.createElement("meta");
            m.name = "description";
            m.content = description;
            document.head.appendChild(m);
        }

        return () => {
            // Cleanup si fuera necesario
        };
    }, []);

    return (
        <Container maxWidth="md" sx={{ py: 6, pt: 16 }}>
            {/* Logo */}
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Box
                    component="img"
                    src={logo}
                    alt="Logo Toppings"
                    sx={{ width: 150, height: "auto" }}
                />
            </Box>

            <Typography variant="h4" component="h1" gutterBottom>
                Términos y Condiciones
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                Toppings Colón — Comida rápida, helados y bebidas
            </Typography>
            <Divider sx={{ my: 2 }} />

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">1. Aceptación de los términos</Typography>
                <Typography paragraph>
                    Al acceder y usar el sitio web https://toppings-colon.web.app/ aceptas cumplir con estos Términos y Condiciones. Si no estás de acuerdo, por favor no uses este sitio.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">2. Objeto</Typography>
                <Typography paragraph>
                    Los presentes términos regulan el uso del sitio web de Toppings, así como la interacción con su menú, productos y servicios. No se gestionan pagos ni ventas directamente a través del sitio.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">3. Uso del sitio</Typography>
                <Typography paragraph>
                    Se prohíbe el uso indebido del sitio, la introducción de contenido ilegal o cualquier intento de comprometer su seguridad.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">4. Propiedad intelectual</Typography>
                <Typography paragraph>
                    Todos los contenidos, imágenes, logos, y diseños son propiedad de Toppings o de terceros colaboradores. No se permite su reproducción sin autorización.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">5. Formularios y contacto</Typography>
                <Typography paragraph>
                    Los formularios permiten enviar información de contacto. Al enviar tus datos, autorizas su uso según nuestra <Link href="/politica-de-privacidad">Política de Privacidad</Link>.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">6. Limitación de responsabilidad</Typography>
                <Typography paragraph>
                    Toppings no se responsabiliza por daños derivados del uso inadecuado del sitio, errores de terceros o circunstancias fuera de nuestro control.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">7. Protección de datos</Typography>
                <Typography paragraph>
                    Los datos personales se tratan conforme a la <Link href="/politica-de-privacidad">Política de Privacidad</Link>. Para ejercer derechos, escribe a <Link href="mailto:info@toppings-colon.web.app">info@toppings-colon.web.app</Link>.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">8. Enlaces externos</Typography>
                <Typography paragraph>
                    El sitio puede contener enlaces a páginas externas que no están bajo nuestro control. No nos hacemos responsables por su contenido ni sus prácticas de privacidad.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">9. Modificaciones</Typography>
                <Typography paragraph>
                    Nos reservamos el derecho de modificar estos Términos y Condiciones. La versión actualizada siempre estará disponible en este sitio.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">10. Legislación aplicable</Typography>
                <Typography paragraph>
                    Estos términos se rigen por la legislación colombiana. Para cualquier disputa, la jurisdicción corresponde al domicilio del proveedor.
                </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography variant="body2" color="text.secondary" paragraph>
                Última actualización: {new Date().toLocaleDateString()}.
            </Typography>

            <Box sx={{ mt: 4, p: 2, bgcolor: "background.paper", borderRadius: 1 }}>
                <Typography variant="subtitle2">Aviso:</Typography>
                <Typography variant="body2">
                    Este documento es informativo y no sustituye asesoramiento legal profesional.
                </Typography>
            </Box>
        </Container>
    );
}
